import { createSelector, select } from '@ngrx/store';
import { selectLayoutState } from './layout.selectors';
import {
  isMobileScreen,
  isSmallScreen
} from './screen.selectors';

export const selectSideBarState = createSelector(
  selectLayoutState,
  (state) => state.sideBar,
);

export const getSideBarConfig = createSelector(
  selectSideBarState,
  (state) => state.config,
);

export const getSideBarLogoSrc = createSelector(
  getSideBarConfig,
  (config) => config.logoSrc || 'https://digitaix.de/img/logo_digitaix_full.png',
);

export const getSideBarLogoWidth = createSelector(
  getSideBarConfig,
  (config) => config.logoWidth || '340px',
);

export const getSideBarLogoHeight = createSelector(
  getSideBarConfig,
  (config) => config.logoHeight || '140px',
);

export const showSideBar = createSelector(
  selectSideBarState,
  isMobileScreen,
  (state, mobileScreen) => state.show && !mobileScreen,
);

export const sideNavMode = createSelector(
  isSmallScreen,
  isSmall => isSmall ? 'over' : 'side',
);

export const sideNavOpen = createSelector(
  isSmallScreen,
  isSmall => !isSmall,
);
